import React, { useCallback } from 'react';
import { createUseStyles, Input } from '@Sage/hoi-poi-ui';

import Size from './Size';

import styles from './styles';

const useStyles = createUseStyles(styles, 'WidgetSize');

function WidgetSize({ onChange, value = { columns: 2, rows: 1 } }) {
    const classes = useStyles();

    const component = useCallback(
        () => (
            <div className={classes.root}>
                <Size column={2} row={1} onChange={onChange} value={value} />
                <Size column={2} row={2} onChange={onChange} value={value} />
                <Size column={3} row={1} onChange={onChange} value={value} />
                <Size column={3} row={2} onChange={onChange} value={value} />
            </div>
        ),
        [classes.root, onChange, value],
    );

    return <Input component={component} className={classes.input} />;
}

export default WidgetSize;
